<template>
<v-app>
  <v-card flat class="hidden-md-and-up" style="padding:0 !important; width: 100%; ">
    <v-container fluid style="padding:0 !important;">
      <v-layout row>
        <div style="width: 100vw;">
          <v-toolbar style="background-color: #2562af !important;border-top-left-radius: 10px !important;border-top-right-radius: 10px !important;box-shadow: 0 0 black !important;height: 30px !important;">
            <v-toolbar-title class="ml-0 pl-0"></v-toolbar-title>
            <!-- <img src="/static/img/icons/logoonechat_full-white.png" style="height: 35px; border-radius: 10px;margin-left: 4vw;cursor: pointer;"> -->
            <v-spacer></v-spacer>
          </v-toolbar>
        </div>
      </v-layout>
    </v-container>
  </v-card>
  <router-view></router-view>
</v-app>
</template>

<script>
import gql from 'graphql-tag'
import { Decode } from '@/services'
import { sync } from 'vuex-pathify'

const SET_USER_ONLINE = gql`
 mutation ($user_id: uuid!) {
  update_users(_set: {last_seen: "now()"}, where: {user_id: {_eq: $user_id}}) {
    affected_rows
  }
}`

export default {
  data() {
    return {
      user_id: ''
    }
  },
  components: {
  },
  computed: {
    ...sync('*')
  },
  watch: {
    
  },
  created () {
    this.user_id = Decode.decodeToken(localStorage.getItem('user_id'))
    
  },
  mounted () {
    var that = this
    setInterval(function(){ 
      that.setUserOneline() 
    }, 2000);
  },
  methods: {
    setUserOneline () {
      this.$apollo.mutate({
        mutation: SET_USER_ONLINE,
        variables: {
          user_id: this.user_id
        }
      })
    }
  }
}
</script>
<style scoped>
>>>.v-toolbar__content {
  height: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mail/LayoutHeader.vue